type UnitData = {
    label: string,
    value: number,
    unit: string,
    translateLabel?: boolean,
    unitKind?: string
}

export class TranslationParser {
    public static parseUnit(t: any, data: UnitData) {
        const {translateLabel = true, unitKind} = data
        const kind = unitKind ? unitKind : data.label.match(/^height|diameter|breadth$/) ? "length" : data.label
        const label = translateLabel ? t(`units.${kind}.${data.label}`) : data.label
        return label + ": " + data.value + t(`units.${kind}.${data.unit}`)
    }

    public static parseUnits(t: any, data: UnitData[]) {
        return data.map(unitData => TranslationParser.parseUnit(t, unitData))
    }

    public static parseUnitLabelSeperated(t: any, data: UnitData) {
        const {translateLabel = true, unitKind} = data
        const kind = unitKind ? unitKind : data.label.match(/^height|diameter|breadth$/) ? "length" : data.label
        const label = translateLabel ? t(`units.${kind}.${data.label}`) : data.label
        return {
            label: label + ": ", value: data.value + t(`units.${kind}.${data.unit}`)
        }
    }

    public static parseUnitsLabelSeperated(t: any, data: UnitData[]) {
            return data.map(unitData => TranslationParser.parseUnitLabelSeperated(t, unitData))
    }
}
